import React, { createContext } from "react";

export const UserDbContent = createContext({id:""});